<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <ChangePasswordForm @close="closeResponse"></ChangePasswordForm>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- <Snackbar :responseMessage="snachbar.message"></Snackbar> -->
  </v-main>
</template>

<script>
// import moment from "moment";
import ChangePasswordForm from "../../components/ChangePasswordForm.vue";
export default {
  name: "ChangePasswordDialog",
  components: {
    ChangePasswordForm,
  },
  data() {
    return {};
  },

  // props: ["dialog"],

  methods: {
    closeResponse() {
      this.$emit("close", true);
    },
  },
  
  computed: {
    
  },

  watch: {},
};
</script>
